import React, { ReactNode, useEffect, useState } from "react";
import Modal from "react-modal";
import { View } from "react-native";
import { Icon, Text } from "react-native-elements";
import { colors, UNIT } from "../styles";

export type TwoChoiceModalProps = {
  openRequests?: number;
  modalHeader: string;
  choice1Header: string;
  choice1Content: ReactNode | ReactNode[];
  choice2Header: string;
  choice2Content: ReactNode | ReactNode[];
  disableClose?: boolean;
};

const styles = {
  header: {
    fontWeight: "bold",
  },
} as const;

export const TwoChoiceModal: React.FC<TwoChoiceModalProps> = ({
  openRequests,
  modalHeader,
  choice1Header,
  choice1Content,
  choice2Header,
  choice2Content,
  disableClose,
}) => {
  const [modalVisible, setModalVisble] = useState(!!openRequests);

  useEffect(() => {
    if (openRequests) {
      setModalVisble(true);
    }
  }, [openRequests]);

  return (
    <Modal
      isOpen={modalVisible}
      onRequestClose={() => setModalVisble(!!disableClose)}
      style={{
        overlay: {
          backgroundColor: `${colors.neutral400}EE`,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        },
        content: {
          inset: "unset",
          padding: UNIT * 2,
        },
      }}
    >
      <View>
        <View style={{ flexDirection: "row" }}>
          <Text h2 style={{ flex: 1 }}>
            {modalHeader}
          </Text>
          {!disableClose && (
            <Icon
              name="x"
              type="feather"
              color={colors.neutral600}
              size={24}
              onPress={() => setModalVisble(false)}
            />
          )}
        </View>

        <View
          style={{
            marginTop: UNIT * 2,
            flexDirection: "column",
            marginBottom: UNIT,
          }}
        >
          <Text style={styles.header}>{choice1Header}</Text>
          {choice1Content}
        </View>

        <View
          style={{
            flexDirection: "column",
            borderStyle: "dashed",
            borderTopWidth: UNIT / 2,
            borderTopColor: colors.neutral200,
            marginTop: UNIT,
            paddingTop: UNIT,
          }}
        >
          <Text style={styles.header}>{choice2Header}</Text>
          {choice2Content}
        </View>
      </View>
    </Modal>
  );
};
